/******************************************** accordion block  ***************************************************/

document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.wd-blocks-accordion')
  
  if ( accordions.length ) {
    accordions.forEach( accordion => {
      const options = accordion.dataset.options
      
      const title = accordion.querySelector('.wd-blocks-accordion__title')
      
      const content = accordion.querySelector('.wd-blocks-accordion__content')
      const icon = accordion.querySelector('.wd-blocks-accordion__title__icon')
      
      if ( !options.initiallyOpen ) {
        content.classList.toggle( 'accordion-hide' )
        icon.classList.toggle( 'accordion-hide' )
      }
  
        title.addEventListener("click", (e) => {
          const currentContent = e.target.closest('.wd-blocks-accordion').querySelector('.wd-blocks-accordion__content')
          const currentIcon = e.target.closest('.wd-blocks-accordion').querySelector('.wd-blocks-accordion__title__icon')
          currentContent.classList.toggle('accordion-hide')
          currentIcon.classList.toggle('accordion-hide')
          if ( options.autoClose && !currentContent.classList.contains('accordion-hide') ) {
            accordions.forEach( accordion => {
              const currentId = currentContent.getAttribute('id')
              if ( currentId !== accordion.querySelector('.wd-blocks-accordion__content').getAttribute('id') ) {
                accordion.querySelector('.wd-blocks-accordion__content').classList.add('accordion-hide')
                accordion.querySelector('.wd-blocks-accordion__title__icon').classList.add('accordion-hide')
              }
            })
          }
        })
    })
  }
}, false);